import driverSchema from './store';
const driverReducer = (state={
    ...driverSchema
}, action) =>{
    switch(action.type){
        case 'INITIAILIZE_DRIVER':
        return{
            ...state,
            ...action.payload
        }
        default:
        return{
            ...state
        }
    }
}

export default driverReducer;


// WEBPACK FOOTER //
// ./src/Driver/reducer.js